var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAseanUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M0 24h30V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    d: "M15 17.72a5.72 5.72 0 1 0 0-11.44 5.72 5.72 0 0 0 0 11.44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e300",
    d: "M13.46 12c-.99-.59-1.46-1.78-1.46-3h.45v.04c0 .42.08 1.86 1.17 2.96a4.3 4.3 0 0 0-1.17 2.96V15H12c0-1.22.47-2.41 1.46-3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e300",
    d: "M12.61 9.04V9h.46v.05c0 .42.08 1.81.88 2.95a5.5 5.5 0 0 0-.88 2.95V15h-.46v-.04c0-.4.1-1.85 1.18-2.96a4.5 4.5 0 0 1-1.18-2.96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e300",
    d: "m14.11 12-.03-.04a5.4 5.4 0 0 1-.85-2.9V9h.46v.07c0 .44.05 1.77.58 2.93a8 8 0 0 0-.58 2.93V15h-.46v-.05c0-.41.05-1.67.85-2.91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e300",
    d: "M14.43 12a8 8 0 0 1-.58-3h.46v.14c0 .5.03 1.72.28 2.86a14 14 0 0 0-.28 3h-.46v-.07c0-.43.05-1.8.58-2.92"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e300",
    d: "M14.76 12v-.02a14 14 0 0 1-.29-2.84V9h.45v6h-.45v-.14c0-.49.03-1.72.29-2.84"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e300",
    d: "M16.54 12c.99-.59 1.46-1.78 1.46-3h-.45v.04A4.3 4.3 0 0 1 16.38 12a4.3 4.3 0 0 1 1.17 2.96V15H18c0-1.22-.47-2.41-1.46-3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e300",
    d: "M17.39 9.04V9h-.46v.05c0 .42-.08 1.81-.88 2.95.8 1.14.88 2.53.88 2.95V15h.46v-.04c0-.4-.1-1.85-1.18-2.96a4.5 4.5 0 0 0 1.18-2.96"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e300",
    d: "m15.89 12 .03-.04c.8-1.24.85-2.5.85-2.9V9h-.46v.07c0 .44-.05 1.77-.58 2.93a8 8 0 0 1 .58 2.93V15h.46v-.05c0-.41-.05-1.67-.85-2.91"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e300",
    d: "M15.57 12a8 8 0 0 0 .58-3h-.46v.14c0 .5-.03 1.72-.28 2.86.25 1.14.28 2.37.28 2.86V15h.46v-.07c0-.43-.05-1.8-.58-2.92"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9e300",
    d: "M15.24 12v-.02c.26-1.12.29-2.35.29-2.84V9h-.45v6h.45v-.14c0-.49-.03-1.72-.29-2.84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAseanUnion);
export default __webpack_public_path__ + "static/media/asean-union.fe0a31a6694639e157fe7c0da3fe6edb.svg";
export { ForwardRef as ReactComponent };